module.exports = __webpack_public_path__ + "static/media/mode-61.94085b4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-61.svg
// module id = 1033
// module chunks = 2